import { getAuth, signOut } from 'firebase/auth'
import { NavigateFunction } from 'react-router'
import { clearReduxStateData } from './clear-user-data'
import { kSessionStorageActiveMatterIdKey } from '@/matter/constants'
import { kSessionStorageSubscriptionNoticeBannerDismissedKey } from '@/account/constants'

/**
 * Sign Out Of App
 * Calls the firebase authentication sign out function
 */
export default async function signOutOfApp(navigate?: NavigateFunction) {
  const auth = getAuth()

  // Navigate to dashboard
  if (navigate) navigate('/dashboard')

  // Clear state data
  clearReduxStateData()

  // Remove active matter id from session storage
  sessionStorage.removeItem(kSessionStorageActiveMatterIdKey)

  // Remove subscription notice banner dismissed flag from session storage
  sessionStorage.removeItem(kSessionStorageSubscriptionNoticeBannerDismissedKey)

  // Firebase sign out
  await signOut(auth)
}
